import { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import TextLink from '@/components/TextLink';

const TextLinkComponent = ({ href, text }: { readonly href: string; readonly text: string }) => (
  <TextLink href={href}>{text}</TextLink>
);

const SupportInfo = () => {
  const { experienceSettings } = useContext(PageContext);
  const { t } = useTranslation();

  if (!experienceSettings?.supportEmail && !experienceSettings?.supportWebsiteUrl) {
    return null;
  }

  const { supportEmail, supportWebsiteUrl } = experienceSettings;

  return (
    <div className="mt-6 flex flex-col gap-3 text-sm whitespace-pre-wrap text-muted">
      {supportEmail && (
        <p>
          <Trans
            components={{
              link: <TextLinkComponent href={`mailto:${supportEmail}`} text={supportEmail} />,
            }}
          >
            {t('description.support_email')}
          </Trans>
        </p>
      )}
      {supportWebsiteUrl && (
        <p>
          <Trans
            components={{
              link: <TextLinkComponent href={supportWebsiteUrl} text={supportWebsiteUrl} />,
            }}
          >
            {t('description.support_website')}
          </Trans>
        </p>
      )}
    </div>
  );
};

export default SupportInfo;
